import React from "react";
import { useLanguage } from "../../../../contexts/LanguageContext";

export function PosterTitle({ title }) {
  const { t } = useLanguage();

  return (
    <div
      className="flex-shrink-0"
      style={{ paddingTop: 6, paddingBottom: 4, minHeight: 54 }}
    >
      <h2
        className="text-base font-bold text-white break-words"
        style={{
          lineHeight: 1.6,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          overflowWrap: "break-word",
        }}
      >
        {title || t("noTitle")}
      </h2>
    </div>
  );
}
